import { FullScreenManager } from './FullScreenManager';
import { ControlsUtils } from './ControlsUtils';
class _MainWindowManager {
    constructor() {
        this.Factory = null;
        this.FullLogPanel = null;
        this.TypesManagerScreen = null;
        this.AsyncCloseObject = null;
        this.portfolioWindow = null;
        this.mainWindow = null;
        this.terceraAccountLookupDropDownForm = null;
        this.terceraInstrumentLookupDropDownForm = null;
        this.terceraIndicatorLookupDropDownForm = null;
        this.changePasswordScreen = null;
        const fullscreenEventTypes = [
            'fullscreenchange',
            'webkitfullscreenchange',
            'mozfullscreenchange',
            'msfullscreenchange'
        ];
        fullscreenEventTypes.forEach((eventType) => {
            document.addEventListener(eventType, this.handleFullscreenChange, false);
        });
    }
    get MainWindow() {
        return this.mainWindow;
    }
    set MainWindow(value) {
        this.mainWindow = value;
    }
    get TerceraAccountLookupDropDownForm() {
        return FullScreenManager.IsFullScreenMode
            ? FullScreenManager.AccountLookupDropDownForm
            : this.terceraAccountLookupDropDownForm;
    }
    set TerceraAccountLookupDropDownForm(form) {
        this.terceraAccountLookupDropDownForm = form;
    }
    get TerceraInstrumentLookupDropDownForm() {
        return FullScreenManager.IsFullScreenMode
            ? FullScreenManager.InstrumentLookupDropDownForm
            : this.terceraInstrumentLookupDropDownForm;
    }
    set TerceraInstrumentLookupDropDownForm(form) {
        this.terceraInstrumentLookupDropDownForm = form;
    }
    get TerceraIndicatorLookupDropDownForm() {
        return FullScreenManager.IsFullScreenMode
            ? FullScreenManager.IndicatorLookupDropDownForm
            : this.terceraIndicatorLookupDropDownForm;
    }
    set TerceraIndicatorLookupDropDownForm(form) {
        this.terceraIndicatorLookupDropDownForm = form;
    }
    get LoginScreen() {
        var _a, _b;
        return (_b = (_a = this.MainWindow) === null || _a === void 0 ? void 0 : _a.Controls) === null || _b === void 0 ? void 0 : _b.loginScreen;
    }
    get ChangePasswordScreen() {
        return this.changePasswordScreen;
    }
    set ChangePasswordScreen(screen) {
        this.changePasswordScreen = screen;
    }
    get IsWorkMode() {
        var _a, _b;
        return (_b = (_a = this.MainWindow) === null || _a === void 0 ? void 0 : _a.IsWorkMode) !== null && _b !== void 0 ? _b : false;
    }
    get CurrentMainWindow() {
        return FullScreenManager.IsFullScreenMode
            ? ControlsUtils.getRactiveFromHTMLElement(document.fullscreenElement)
            : this.mainWindow;
    }
    AddControl(control, customPlace = false) {
        const currentMainWindow = this.CurrentMainWindow;
        currentMainWindow === null || currentMainWindow === void 0 ? void 0 : currentMainWindow.addControl(control, customPlace);
    }
    GetScreen(type) {
        var _a;
        const currentMainWindow = this.CurrentMainWindow;
        if (isNullOrUndefined(currentMainWindow)) {
            return null;
        }
        const controls = Object.values(currentMainWindow.Controls);
        for (const control of controls) {
            const controlType = (_a = control === null || control === void 0 ? void 0 : control.getType) === null || _a === void 0 ? void 0 : _a.call(control);
            if (controlType === type) {
                return control;
            }
        }
        return null;
    }
    handleFullscreenChange(event) {
        FullScreenManager.HandleFullscreenChange(event);
    }
}
export const MainWindowManager = new _MainWindowManager();
